import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html, nothing } from "lit";
import { baseStyle, imgClasses, badgeClasses, baseClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfThumbProfile = class extends BaseComponent {
  render() {
    const image = this.dsf_src ? html` <img
          @load=${(e) => e.target.removeAttribute("style")}
          style="visibility: hidden"
          class=${imgClasses}
          src=${this.dsf_src}
        />` : nothing;
    const badge = this.dsf_badge ? html` <span class=${badgeClasses}> ${this.dsf_badge} </span>` : nothing;
    return html`
      <div class=${baseClasses(this)} data-skeleton>
        <slot></slot>
        ${image} ${badge}
      </div>
    `;
  }
};
DsfThumbProfile.styles = baseStyle;
__decorateClass([
  prop({ type: String })
], DsfThumbProfile.prototype, "dsf_badge", 2);
__decorateClass([
  prop({ type: String })
], DsfThumbProfile.prototype, "dsf_src", 2);
DsfThumbProfile = __decorateClass([
  defineElement("dsf-thumb-profile")
], DsfThumbProfile);
export {
  DsfThumbProfile
};
